import { Checkbox } from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import React from "react";
import "./overhaulYear.scss";
import NumberInput from "../../sharedComponents/numberInput/numberInput";
import { ValidatedValue } from "../../../helpers/validator";

interface OverhaulYearProps {
  value: ValidatedValue<number | null>;
}

interface OverhaulYearState {
  checkboxChecked: boolean;
}

export default class OverhaulYear extends React.Component<OverhaulYearProps, OverhaulYearState> {

  constructor(props: OverhaulYearProps) {
    super(props);

    this.state = {
      checkboxChecked: false
    };
  }

  public componentDidMount() {
    this.setState({ checkboxChecked: (!!this.props.value.value && Number(this.props.value.value) > 0) });
  }

  public render() {
    return (
      <div className="overhaul-year">
        <Checkbox
          className="checkbox"
          checked={this.state.checkboxChecked}
          onChange={(event) => this.handleCheckboxChange(event)}
          color="secondary"
          icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 30 }} />}
          checkedIcon={<CheckBoxIcon style={{ fontSize: 30 }} />}
          disableRipple
        />
        {this.state.checkboxChecked && (
          <NumberInput validatedValue={this.props.value}
            formatted={false}
            topLabel="Rok remontu generalnego"
            maxLength={4}
          />
        )}
      </div>
    );
  }

  private handleCheckboxChange(event: any) {
    const value = event.target.checked;
    this.setState({ checkboxChecked: value });

    if (!value) {
      this.props.value.setValue(null);
    } else {
      this.props.value.clearValidation();
    }
  }
}
